<template>
  <div>
    <section class="">
      <div
        class="banner"
        :style="{backgroundImage: `url(/static/images/petbanners.jpg)`,backgroundSize: `100% 100%`,'height': `380px` }"
      />
    </section>
    <section class="container">
      <div v-if="step === 1">
        <div class="fz-small mb-m">
          <h3>恩點 Mercifür x 磐石寵物保險｜無穀天然糧問卷調查</h3>
          <p style="text-indent : 2em ;">已超過 200 組毛孩家庭試用，挑食、便便、體重改善可見！</p>          
          <p
            style="text-indent : 4em ;"
          >蛋白質含量 35%</p>
          <p style="text-indent : 4em ;">單一新鮮肉源製成</p>
          <p
            style="text-indent : 4em ;"
          >每公斤添加 40 億益生菌及益生質</p>
          <p
            style="text-indent : 4em ;"
          >添加蛋黃卵磷脂、人用級凍乾粉</p>
          <p
            style="text-indent : 4em ;"
          >完成問卷，搶先收到隨身包體驗</p>
        </div>
        <div class="text-center mb-m">
          <Button v-show="isLogin === false" 
            class="btn-m btn-primary"
            :style="{margin: '0 15px'}"
            @click="next"
            v-text="'已是會員'"
          />
          <Button v-show="isLogin === true"
            class="btn-m btn-primary"
            :style="{margin: '0 15px'}"
            @click="next"
            v-text="'填寫'"
          />
          <router-link to="/signup">
            <Button v-show="isLogin === false" class="btn-m btn-tertiary" v-text="'尚未成為會員，去註冊'" />
          </router-link>
        </div>
        <div class="note">
          <div class="note-header"></div>
          <p>           
          </p>
        </div>
      </div>
      <div v-if="step === 2">
        <h2 class="mb-s" v-text="`填寫問卷`" />
        <Form
          ref="reserveData"
          label-position="left"
          :label-width="260"
          :model="model"
          :rules="rules"
          class="form-flex middle"
        >
        <BaseVueSelect
            v-model="model.catNo"
            label="請問您的家裡總共有幾隻貓呢？"
            prop="catNo"            
            :options="insurance_kind_list" 
          />
        <BaseInput
        v-if="model.catNo!='0'"
        v-model="model.catName"
        prop="catName"
        label="請問寶貝貓們的 名字 和 品種 分別是？"
        placeholder="例如：1. 公主，波斯貓、2. 大Ｑ，英國短毛貓。盡量全部都寫上來唷"   
      />
      <BaseVueSelect
            v-model="model.dogNo"
            label="請問您的家裡總共有幾隻犬呢？"
            prop="dogNo"           
            :options="insurance_kind_list"  
          />
        <BaseInput
        v-if="model.dogNo!='0'"
        v-model="model.dogName"
        prop="dogName"
        label="請問寶貝犬們的名字和品種分別是？"
        placeholder="例如：1. 呆呆，黃金獵犬、2. 妮妮，混種犬。盡量全部都寫上來唷"  
      />   
          <GroupRadio
      v-model="model.needPetInsu"
      prop="needPetInsu"
      type="button"
      label="請問您是否有購買寵物險？"
      :radios="insurance_NeedPet"
      :label-width="200" 
    />           
        </Form>
        <div class="text-center mt-s">
          <Button class="btn-m btn-primary" @click="handleSubmit" v-text="'送出'" />
        </div>
      </div>
    </section>
    <OkModal v-if="dialog" 
    :okMsg="okMsg" />
  </div>
</template>
<script>
//npm
import { PetFoodInfo } from "@/utils/axios";
//vuex
import { mapState, mapMutations } from "vuex";
import { Button, Form, Checkbox } from "iview";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
import GroupRadio from "@/components/forms/elements/GroupRadio";
import BaseInput from "@/components/forms/elements/BaseInput";
// validate rules
import {
  needPetInsu,
  catNo,
  dogNo,
  catName,
  dogName 
} from "@/utils/asyncValidator/rules";
import OkModal from "@/components/modals/OKModal";
import format from "date-fns/format";
import { UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION } from "@/store/modules/user/constants";

export default {
  components: {
    Button,
    Form,
    Checkbox,
    BaseInput,
    GroupRadio,
    BaseVueSelect,
    OkModal
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    insurance_kind_list: {
      type: Array,
      default: [
        { label: "無此類型寵物", value: "0" },
        { label: "1隻", value: "1" },
        { label: "2隻", value: "2" },
        { label: "3隻", value: "3" },
        { label: "4隻", value: "4" },
        { label: "5隻或更多", value: "9" },
      ]
    },
    insurance_NeedPet: {
      type: Array,
      default: [
        { label: "有，已經有買寵物險", value: "1" },
        { label: "沒有，我想了解寵物險", value: "2" },
        { label: "沒有，暫時不需要", value: "3" },      
      ]
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {    
      const petCheck = (rule, value, callback) => {
        const { catNo,dogNo } = this.model;      
        //console.log("catNo+dogNo--"+ (catNo+dogNo)<1);
         if (!value) return callback(new Error('請確認您的寶貝們的 名字 和 品種'));        
        if ((catNo+dogNo)<1) return callback(new Error('請再次確認您的寵物數量'));        
        callback();
      };

    return {
      rules: { 
      needPetInsu,
      catNo, 
      dogNo: [{ required: true, validator: petCheck, trigger: 'blur' }] ,
      catName,
      dogName,      
      },
      model: {
        catNo:"0",        
        catName: "",
        dogNo:"0",        
        dogName: "",
        needPetInsu: "1"
      },
      okMsg:
      {
       title:"恭喜您已完成問卷", 
       msgcontent:"我們已經收到您資料，一個月後將由專人為您送達隨身包!"
      },
      petnumber:"0"
    };
  }, 
  computed: {
    step() {
      const { step } = this.$route.params;
      return step || 1;
    }
  },
  methods: {
    ...mapMutations([UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION]),
    async next() {
      const activityData = { name: "activityReservePetInsuReserve" };
      await this.$store.commit(
        UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION,
        activityData
      );
      this.$router.push({
        name: "activityReservePetInsuReserve",
        params: {
          step: 2
        }
      });
    },
    async handleSubmit() {
      const { model, $refs } = this;      
      const isValid = await $refs.reserveData.validate(v => v);      
      if (!isValid) return;      
      const ajaxStatus = await PetFoodInfo(model);
      if (ajaxStatus) {       
        this.dialog = true;        
              }    
    }    
  }
};
</script>